"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkboxFreeNullLink = exports.FreeVariables = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
const react_bootstrap_1 = require("react-bootstrap");
const OpenSankey_1 = require("./OpenSankey");
const SankeyUtils_1 = require("open-sankey/dist/configmenus/SankeyUtils");
const fa_1 = require("react-icons/fa");
const FreeVariables = (t, dict_variable_application_data, dict_variable_elements_selected, node_function, link_function) => {
    const { data } = dict_variable_application_data;
    const { multi_selected_links } = dict_variable_elements_selected;
    const newEntries = new Map(Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
        return (Object.keys(dataTag.tags).length > 0) ? [
            dataTagKey,
            Object.entries(dataTag.tags).filter(tag => tag[1].selected).length > 0 ? Object.entries(dataTag.tags).filter(tag => tag[1].selected)[0][0] : Object.keys(dataTag.tags)[0]
        ] : ['n', 'n'];
    }));
    const tags_selected = Object.fromEntries(newEntries);
    const value_selected = (0, OpenSankey_1.ValueSelectedParameter)(dict_variable_application_data, multi_selected_links, tags_selected);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Checkbox, { variant: 'menuconfigpanel_option_checkbox', isChecked: (value_selected && value_selected.extension && value_selected.extension.display_thin), iconColor: (value_selected && value_selected.extension && value_selected.extension.display_thin) ? '#78C2AD' : 'white', onChange: () => {
                let val = Object(multi_selected_links.current[0].value);
                const node_to_update = [];
                multi_selected_links.current.map(d => {
                    node_to_update.push(data.nodes[d.idSource]);
                    node_to_update.push(data.nodes[d.idTarget]);
                    val = d.value;
                    Object.values(tags_selected).forEach(tag => {
                        if (val[tag] === undefined) {
                            val[tag] = {};
                        }
                        val = val[tag];
                    });
                    val.extension.display_thin = !val.extension.display_thin;
                });
                node_function.RedrawNodes(node_to_update);
                link_function.RedrawLinks(multi_selected_links.current);
            } },
            t('Flux.data.astr'),
            react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, t('Menu.featureBeta')))));
};
exports.FreeVariables = FreeVariables;
const checkboxFreeNullLink = (applicationData, t, node_function, link_function) => {
    const { data, display_nodes, display_links } = applicationData;
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    return react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
        react_1.default.createElement(react_bootstrap_1.Col, null,
            react_1.default.createElement(react_2.Checkbox, { sx: (0, SankeyUtils_1.SmoothClasses)({}), icon: data.free_null_link_visible ? react_1.default.createElement(fa_1.FaEye, { style: { fill: 'white' } }) : react_1.default.createElement(fa_1.FaEyeSlash, null), isChecked: data.free_null_link_visible, onChange: (evt) => {
                    data.free_null_link_visible = evt.target.checked;
                    node_function.recomputeDisplayedElement();
                    node_function.RedrawNodes(Object.values(display_nodes));
                    link_function.RedrawLinks(Object.values(display_links));
                    setForceUpdate(!forceUpdate);
                } },
                t('Flux.data.fla'),
                react_1.default.createElement(react_bootstrap_1.Badge, { pill: true, bg: "info", style: { marginLeft: 'auto' } }, t('Menu.featureBeta')))));
};
exports.checkboxFreeNullLink = checkboxFreeNullLink;
